import { AccountTypeFormField } from '../Steps/TypeOfRetirementAccount/TypeOfRetirementAccount';
import {
  WorkflowActions,
  WorkflowCurrentStepFC,
  WorkflowData,
} from '../../AutoAccountWorkflow.types';
import { BirthdateFormField } from '../Steps/YourDateOfBirth/YourDateOfBirth';
import { TotalInvestableAssetsFormField } from '../Steps/TotalValueInvestableAssets/TotalValueInvestableAssets';
import { HowMuchSavedFormField } from '../Steps/HowMuchSavePerMonth/HowMuchSavePerMonth';
import { SimpleIraPlanNameFormField } from '../Steps/SimpleIraPlanName/SimpleIraPlanName';

export interface FormFields
  extends AccountTypeFormField,
    SimpleIraPlanNameFormField,
    BirthdateFormField,
    TotalInvestableAssetsFormField,
    HowMuchSavedFormField {}

export interface UseRetirementWorkflowData extends WorkflowData<WorkflowCurrentStepFC> {}

export interface UseRetirementWorkflowActions
  extends WorkflowActions<
    | AccountTypeFormField
    | SimpleIraPlanNameFormField
    | BirthdateFormField
    | TotalInvestableAssetsFormField
    | HowMuchSavedFormField
  > {}

export enum StepKey {
  AccountType = 'accountType',
  SimpleIraPlanName = 'simpleIraPlanName',
  Birthday = 'birthday',
  TotalInvestableAssets = 'totalInvestableAssets',
  HowMuchSaved = 'HowMuchSaved',
}

export type Step = (formValues: FormFields) => WorkflowCurrentStepFC;

export type StepMap = Record<StepKey, Step>;

export type ValidationPerStep = Record<StepKey, Array<keyof FormFields>>;
